import StrategyCallbacks from '../../../../enums/StrategyCallbacks';
export default {
    [StrategyCallbacks.Initialize]: (operationData) => {
        const { centerSegmentIndex } = operationData.configuration || {};
        if (!centerSegmentIndex) {
            return;
        }
        operationData.segmentIndex = centerSegmentIndex.segmentIndex;
    },
    [StrategyCallbacks.OnInteractionStart]: (operationData) => {
        const { segmentIndex, previewSegmentIndex, segmentationVoxelManager, centerIJK, viewPlaneNormal, segmentationImageData, preview, configuration, } = operationData;
        if (!configuration?.useCenterSegmentIndex) {
            return;
        }
        delete configuration.centerSegmentIndex;
        let hasSegmentIndex = false;
        let hasPreviewIndex = false;
        const nestedBounds = [
            ...segmentationVoxelManager.getBoundsIJK(),
        ];
        if (Math.abs(viewPlaneNormal[0]) > 0.8) {
            nestedBounds[0] = [centerIJK[0], centerIJK[0]];
        }
        else if (Math.abs(viewPlaneNormal[1]) > 0.8) {
            nestedBounds[1] = [centerIJK[1], centerIJK[1]];
        }
        else if (Math.abs(viewPlaneNormal[2]) > 0.8) {
            nestedBounds[2] = [centerIJK[2], centerIJK[2]];
        }
        const callback = ({ value }) => {
            hasSegmentIndex ||= value === segmentIndex;
            hasPreviewIndex ||= value === previewSegmentIndex;
        };
        segmentationVoxelManager.forEach(callback, {
            imageData: segmentationImageData,
            isInObject: operationData.isInObject,
            boundsIJK: nestedBounds,
        });
        if (!hasSegmentIndex && !hasPreviewIndex) {
            return;
        }
        let existingValue = segmentationVoxelManager.getAtIJKPoint(centerIJK);
        if (existingValue === previewSegmentIndex) {
            if (preview) {
                existingValue = preview.segmentIndex;
            }
            else {
                return;
            }
        }
        else if (hasPreviewIndex) {
            existingValue = null;
        }
        operationData.segmentIndex = existingValue;
        configuration.centerSegmentIndex = {
            segmentIndex: existingValue,
        };
    },
};
